<template>
  <v-container class="programs">
    <v-card
      class="py-4 px-2 auth-content"
      tile
    >
      <v-form ref="form">
        <PageTitle
          main="Administração"
          icon="mdi-pencil-box-outline"
          sub="Programas e icones"
          home="/administracao"
        />
        <Form />
      </v-form>
    </v-card>
  </v-container>
</template>

<script>
import PageTitle from '@/components/template/PageTitle'
import Form from '../parametros/programs'
export default {
  name: 'Programs',
  components: { PageTitle, Form },
  data: () => ({

  })
}
</script>
